import { AnimatePresence, motion } from 'motion/react';
import { X, TrendingUp, Facebook, Twitter } from 'lucide-react';

interface AboutModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function AboutModal({ isOpen, onClose }: AboutModalProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-6">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-zinc-900/60 backdrop-blur-sm"
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="relative w-full max-w-sm bg-white dark:bg-black border border-zinc-100 dark:border-zinc-900 rounded-[32px] shadow-2xl overflow-hidden transition-colors"
          >
            <div className="p-8 flex flex-col items-center text-center space-y-6">
              <div className="w-20 h-20 bg-indigo-600 rounded-3xl flex items-center justify-center shadow-xl shadow-indigo-200 dark:shadow-indigo-900/20 mb-2">
                <TrendingUp className="text-white w-10 h-10" />
              </div>
              
              <div className="space-y-2">
                <h2 className="text-2xl font-bold text-zinc-900 dark:text-zinc-100">Kówópé</h2>
                <p className="text-sm text-zinc-500 dark:text-zinc-400">Version 1.0.0</p>
              </div>

              <p className="text-sm text-zinc-600 dark:text-zinc-300 leading-relaxed">
                Kówópé is a comprehensive personal finance tracker designed to help you manage expenses, track assets, and monitor your financial health with ease.
              </p>

              <div className="w-full h-px bg-zinc-100 dark:bg-zinc-800" />

              <div className="space-y-4 w-full">
                <p className="text-[10px] font-bold text-zinc-400 uppercase tracking-widest">Connect</p>
                <div className="flex justify-center gap-4">
                  <a href="https://www.facebook.com/kowopefinance" rel="noopener noreferrer" target="_blank" className="p-3 bg-zinc-50 dark:bg-zinc-900 rounded-2xl text-zinc-600 dark:text-zinc-400 hover:text-zinc-900 dark:hover:text-zinc-100 transition-colors">
                    <Facebook className="w-5 h-5" />
                  </a>
                  <a href="https://twitter.com/kowopefinance" rel="noopener noreferrer" target="_blank" className="p-3 bg-zinc-50 dark:bg-zinc-900 rounded-2xl text-zinc-600 dark:text-zinc-400 hover:text-zinc-900 dark:hover:text-zinc-100 transition-colors">
                    <Twitter className="w-5 h-5" />
                  </a>
                </div>
              </div>

              <button
                onClick={onClose}
                className="absolute top-4 right-4 p-2 bg-zinc-50 dark:bg-zinc-900 rounded-full text-zinc-400 hover:text-zinc-900 dark:hover:text-zinc-100 transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            
            <div className="bg-zinc-50 dark:bg-zinc-900/50 p-4 text-center">
              <p className="text-[10px] text-zinc-400">
                © {new Date().getFullYear()} Kówópé Finance. All rights reserved.
              </p>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
